(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filterable-gallery"] && !Shopify.designMode) return;
  try {
    
  class FilterableGallery extends HTMLElement {
    constructor() {
      super();
      this.currentFilter = '*';
      this.itemsPerPage = parseInt(this.dataset.itemsPerPage, 10) || 8;
      this.visibleCount = this.itemsPerPage;
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.filterable-gallery__tab');
      this.items = Array.from(this.querySelectorAll('.filterable-gallery__item'));
      this.seeMoreBtn = this.querySelector('[data-see-more]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.handleTabClick(tab));
        tab.addEventListener('keydown', (e) => this.handleTabKeydown(e));
      });

      if (this.seeMoreBtn) {
        this.seeMoreBtn.addEventListener('click', () => this.handleSeeMore());
      }

      this.render();
    }

    handleTabClick(tab) {
      this.tabs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      this.currentFilter = tab.dataset.filter;
      this.visibleCount = this.itemsPerPage; // reset pagination on filter change
      this.render();
    }

    handleTabKeydown(e) {
      // Arrow-key navigation between tabs (a11y)
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(e.key)) return;
      e.preventDefault();
      const tabsArr = Array.from(this.tabs);
      const currentIdx = tabsArr.indexOf(document.activeElement);
      let nextIdx = currentIdx;
      if (e.key === 'ArrowRight') nextIdx = (currentIdx + 1) % tabsArr.length;
      if (e.key === 'ArrowLeft') nextIdx = (currentIdx - 1 + tabsArr.length) % tabsArr.length;
      if (e.key === 'Home') nextIdx = 0;
      if (e.key === 'End') nextIdx = tabsArr.length - 1;
      tabsArr[nextIdx].focus();
      tabsArr[nextIdx].click();
    }

    handleSeeMore() {
      this.visibleCount += this.itemsPerPage;
      this.render();
    }

    render() {
      // Step 1: figure out which items match the current filter
      const matching = this.items.filter((item) => {
        return this.currentFilter === '*' || item.dataset.category === this.currentFilter;
      });

      // Step 2: hide non-matching items
      this.items.forEach((item) => {
        if (!matching.includes(item)) item.hidden = true;
      });

      // Step 3: show only the first N matching items
      matching.forEach((item, idx) => {
        item.hidden = idx >= this.visibleCount;
      });

      // Step 4: toggle the "See More" button
      if (this.seeMoreBtn) {
        this.seeMoreBtn.hidden = this.visibleCount >= matching.length;
      }
    }
  }

  if (!customElements.get('filterable-gallery')) {
    customElements.define('filterable-gallery', FilterableGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
